<template>
    <div id="app">
        <keep-alive>
            <router-view class="router-view-c" :key="this.$route.fullPath"></router-view>
        </keep-alive>
    </div>
</template>

<script>

    export default {
        name: 'App',
        data() {
            return {
                transitionName: 'none'
            }
        }
    }
</script>

<style>
    #app {
        font-family: "Noto Sans KR", sans-serif !important;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        -webkit-touch-select: none;
        -ms-user-select: none;
        -moz-user-select: none;
        -webkit-user-select: none;
        -user-select: none;
        text-align: center;
        color: #2c3e50;
        height: 100%;
        max-width: 1024px;
        margin-left: auto;
        margin-right: auto;
    }

    .forward-enter,
    .back-leave-active {
        opacity: 0;
        transform: translateX(100%);
    }

    .forward-leave-active,
    .back-enter {
        opacity: 0;
        transform: translateX(-100%);
    }

    .router-view-c {
        transition: transform 0.3s;
    }
</style>
